import React from "react";
import "./App.scss";
import "./styles/css/custom.scss";
import { Layout, Modal } from "antd";
import Router from "./routers/router.jsx";
import { HashRouter, useHistory } from "react-router-dom";
import AppLoading from "./component/Util/AppLoading";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";

function App() {
  const history = useHistory();

  history.listen(() => {
    Modal.destroyAll();
  });

  return (
    <div className="App">
      <HashRouter>
        <Layout>
          <Router />
        </Layout>
      </HashRouter>
      <AppLoading />
    </div>
  );
}

export default App;
